import { remove } from "lodash";

class DataStore {
  /**
   * The constructor function is a special function that is called when a new instance of an object is
   * created.
   */
  constructor() {
    this.spnAnalytics = [];
    this.appSessionId;
  }

  /**
   * It takes a key and a value, and then it sets the value of the key in localStorage
   * @param key - The key to store the data under.
   * @param value - The value to be stored.
   * @returns The value of the key.
   */
  setData(key, value) {
    this[key] = value;
    if (key === "spnWebSdkAnalytics") {
      this.appSessionId = window.ANALYTICS_CONNECTOR_FRONTEND.appSessionId;
      let thisSessionKey = "ANALYTICS_" + this.appSessionId;
      if (
        localStorage.getItem(thisSessionKey) == null ||
        localStorage.getItem(thisSessionKey) == ""
      ) {
        localStorage.setItem(thisSessionKey, JSON.stringify([]));
        this.handleAllSessionKeys(thisSessionKey);
        //localStorage.setItem(thisSessionKey,[]);
      }
    }
    //localStorage.setItem(key, JSON.stringify(value));
    return true;
  }

  storeUpdateData(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  }

  getStorageData(key) {
    return localStorage.getItem(key);
  }

  /**
   * It returns the value of the key passed to it.
   * @param key - The key to store the data under.
   * @returns The value of the key.
   */
  getData(key) {
    return this[key];
  }

  /**
   * It removes the data from the local storage.
   * @param key - The key to remove from localStorage.
   */
  removeData(key) {
    localStorage.removeItem(key);
  }

  /**
   * It clears the local storage.
   */
  removeAll() {
    localStorage.clear();
  }

  getAppSessionId() {
    return this.appSessionId;
  }

  handleAllSessionKeys(thisSessionKey) {
    if (!localStorage.getItem("ANALYTICS_KEY_LISTS")) {
      localStorage.setItem("ANALYTICS_KEY_LISTS", JSON.stringify([]));
    }
    let allSessionKeysStr = localStorage.getItem("ANALYTICS_KEY_LISTS");
    let allSessionKeys = [];
    try {
      allSessionKeys = JSON.parse(allSessionKeysStr);
      if (!allSessionKeys.includes(thisSessionKey)) {
        allSessionKeys.push(thisSessionKey);
      }
    } catch (e) {
      SPN_Console.error("error", e);
    }
    localStorage.setItem("ANALYTICS_KEY_LISTS", JSON.stringify(allSessionKeys));
  }
}

export default DataStore;
